import { isBoolean } from '@tunasong/models'
import { NoteLib, ScaleLib } from '@tunasong/music-lib'
import type { FC } from 'react'
import { Note } from '../../note/note.js'
import type { NoteLabelProps } from './keyboard.js'

export const NoteLabel: FC<NoteLabelProps> = props => {
  const { note: providedNote, isAccidental, isActive, scale, label } = props
  const note = NoteLib.toNote(providedNote)
  const inScale = scale ? ScaleLib.noteInScale(scale, note) : undefined
  const renderDot = isBoolean(inScale) && label === 'note-scale'
  const renderLabel = label && label !== 'none'

  const dotColor =
    inScale === true
      ? 'var(--tuna-notes-inScale)'
      : inScale === false
        ? 'var(--tuna-notes-outOfScale)'
        : 'var(--tuna-notes-main)'

  return renderLabel ? (
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
      {renderDot ? (
        <div
          style={{
            position: 'relative',
            height: 16,
            width: 16,
            backgroundColor: dotColor,
            borderRadius: '50%',
            alignSelf: isAccidental ? '' : 'center',
            left: isAccidental ? 2 : undefined,
            marginTop: 8,
            marginBottom: 8,
          }}
        />
      ) : null}
      <Note
        note={note}
        scale={scale}
        style={{
          fontSize: '0.8rem',
          backgroundColor: isAccidental ? 'var(--tuna-palette-background-paperChannel)' : undefined,
          color: isAccidental && !isActive ? 'white' : 'black',
        }}
      />
    </div>
  ) : null
}
